import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';

import { BackgroundVariant } from '../types';
import componentStyles from './ghs-hero-provider.css.lit';
import '../../base/outline-container/outline-container';

/**
 * The GHS Hero component
 * @element ghs-hero
 * @slot content
 * @slot breadcrumb - for breadcrumb
 */
@customElement('ghs-hero-provider')
export class GhsHeroProvider extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Changes the background of the component
   * @param backgroundVariant
   * @default 'blue-gradient'
   */
  @property({ attribute: 'background-variant', reflect: true })
  backgroundVariant: BackgroundVariant = 'blue-gradient';

  render(): TemplateResult {
    const classes = {
      'hero-provider': true,
    };

    const bgClasses = {
      background: true,
      [`background--${this.backgroundVariant}`]: true,
    };

    return html`
      <div class="${classMap(classes)}">
        <div class="${classMap(bgClasses)}">
          <outline-container x-padding>
            <slot name="breadcrumb"></slot>
          </outline-container>
        </div>

        <outline-container class="content" x-padding>
          <slot name="content"></slot>
        </outline-container>
      </div>
    `;
  }
}
